module.exports = __webpack_public_path__ + "img/carender-table-icon.c930bba7.svg";